<template>
  <div class="part-base-bd tb" v-if="funcView.part_info_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addEvent" v-if="funcView.part_info_add">{{ funcView.part_info_add }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addBatchPart" v-if="funcView.part_info_import">
            <i class="icon icon-piliangtianjia"></i>
            {{ funcView.part_info_import }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.part_info_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('partExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.part_info_export }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('asm_part_base.ljmcljbh')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table index :column="tableColumn" :data="tableList" @filter="filterChange" @sort="sortChange" height="100%" :slots="['unitPrice', 'partCode', 'action']">
        <template v-slot:unitPrice="scope">
          <span>{{ scope.row.unitPrice ? scope.row.currencyUnit || '' : '' }}{{ scope.row.unitPrice || '-' }}</span>
        </template>
        <template v-slot:partCode="scope">
          <div class="cell-link" v-if="funcView.part_info_view" @click="watchEvent(scope.row)">{{ scope.row.partCode }}</div>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="editEvent(scope.row)" v-if="funcView.part_info_edit">{{ funcView.part_info_edit }}</el-button>
          <el-button type="text" size="mini" @click="deleteEvent(scope.row)" v-if="funcView.part_info_delete">{{ funcView.part_info_delete }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <part-base-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></part-base-dialog>
    <part-base-batch-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onPageChange({ page: 1 })"></part-base-batch-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partBaseDialog from './children/part_base_dialog.vue';
import partBaseBatchDialog from './children/part_base_batch_dialog.vue';

export default {
  components: { partBaseDialog, partBaseBatchDialog },
  name: 'partBase',
  data() {
    return {
      provide: true,
      tableCode: 'part_base',
      formSearch: {
        search: '',
        partType: '',
        replaceMethod: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },

      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      // 入库
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 新增
    addEvent: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('asm_part_base.xin_zeng_ling_jian');
      this.dialogVisible = true;
    },
    // 编辑
    editEvent: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_part_base.bian_ji_ling_jian');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 编辑
    watchEvent: function (data) {
      this.dialogModel.type = 'watch';
      this.dialogModel.title = this.$t('asm_part_base.cha_kan_ling_jian');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    addBatchPart: function () {
      this.dialogVisible1 = true;
    },
    // 删除
    deleteEvent: function (data) {
      if (data.hasReplaceRecord) {
        const tips = this.$t('asm_part_base.bhodljyjczghjlwfsc', [data.partCode]);
        this.$showConfirm(tips);
      } else {
        const tips = this.$t('asm_part_base.nqrscbhodljm', [data.partCode]);
        this.$showConfirm(tips)
          .then(() => {
            this.$postJSON(`${apis.PartDelete}/${data.partId}`).then(() => {
              this.$message({
                message: this.$t('Common.com_delete_success'),
                type: 'success',
              });
              this.getTableList();
            });
          })
          .catch(() => {});
      }
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.PartPage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';

.part-base-bd {
}
</style>
